import { useRef } from 'react';

export class TimeoutManager {
  private timeouts = new Map<string, NodeJS.Timeout>();

  set(key: string, callback: () => void, delay: number): void {
    this.clear(key);
    const timeoutId = setTimeout(callback, delay);
    this.timeouts.set(key, timeoutId);
  }

  clear(key: string): void {
    const existingTimeout = this.timeouts.get(key);
    if (existingTimeout) {
      clearTimeout(existingTimeout);
      this.timeouts.delete(key);
    }
  }

  has(key: string): boolean {
    return this.timeouts.has(key);
  }

  clearAll(): void {
    this.timeouts.forEach((timeout) => clearTimeout(timeout));
    this.timeouts.clear();
  }

  get size(): number {
    return this.timeouts.size;
  }
}

export const useTimeoutManager = () => {
  const managerRef = useRef<TimeoutManager>(new TimeoutManager());
  return managerRef.current;
};
